export default {
  personalProfile: "Fiche personnelle",
  myAccount: "Mon compte",
  back_to_my_account: "Retour sur mon compte",
};
